if (!customElements.get('sc-load-more')) {
  customElements.define(
    'sc-load-more',
    class ScLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.sc-load-more__button');
        this.querySelector('.sc-load-more__fallback').hidden = true;
        this.querySelector('.sc-load-more__controls').hidden = false;
        this.button.addEventListener('click', () => this.load());

        if (this.dataset.mode === 'scroll' && !window.Shopify?.designMode) {
          this.observer = new IntersectionObserver((entries) => entries[0].isIntersecting && this.load(), {
            rootMargin: '0px 0px 600px 0px',
          });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      get grid() {
        return document.querySelector('#ProductGridContainer ul.product-grid');
      }

      async load() {
        if (this.loading || !this.dataset.next || !this.grid) return;
        this.loading = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

        const sectionId = this.grid.closest('[data-id]')?.dataset.id || this.grid.dataset.id;
        const url = new URL(this.dataset.next, window.location.origin);
        if (sectionId) url.searchParams.set('section_id', sectionId);

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = html.querySelectorAll('ul.product-grid > li');
          const grid = this.grid;
          grid.append(...items);

          // Keep the address bar on the page loaded, so a reload or Back lands near here.
          const visible = new URL(this.dataset.next, window.location.origin);
          window.history.replaceState(window.history.state, '', `${visible.pathname}${visible.search}`);

          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);

          const next = html.querySelector('sc-load-more');
          if (next) {
            this.replaceWith(next);
          } else {
            this.remove();
          }
        } catch (error) {
          // Leave the numbered links as the way on.
          this.querySelector('.sc-load-more__fallback').hidden = false;
          this.querySelector('.sc-load-more__controls').hidden = true;
          this.observer?.disconnect();
        } finally {
          this.loading = false;
          this.button.removeAttribute('aria-busy');
          this.button.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }
    }
  );
}
